import { useState, useEffect, useRef } from "react";
import axios from "axios";

import { PaginationBtn } from "../../../../../styledEvents";
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import ModalEmitidasArquivo from "./EmitidasArquivo";
import PendentesEmitir from "./PendentesEmitir";
import { Switch, Skeleton, Input, Select } from 'antd';
import EmitidasEditar from "./EmitidasEditar";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TabelasEmitidasPendentes from "./Tabelas/EmitidasPendentes";
import { FieldContainer } from "../../../../../CSSGlobal";
import { CircularProgress } from "@mui/material";

import "./style.css"

export function SituacaoTarefa({ idTarefa, selectedArea, clientId, carteira, equipe, dataVencimento }) {

  const [listTableTarefasPendentes, setListTableTarefasPendentes] = useState([]);
  const [listTableTarefasEmitidas, setListTableTarefasEmitidas] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [reportType, setReportType] = useState("");

  const [page, setPage] = useState(1);
  const Numberpage = 5;
  const [showPendentes, setShowPendentes] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [originalListPendentes, setOriginalListPendentes] = useState([]);
  const [originalListEmitidas, setOriginalListEmitidas] = useState([]);

  const [idFile, setIsIdFile] = useState("");
  const [Dadoscontexto, setDadosContexto] = useState();
  const startIndex = (page - 1) * Numberpage;
  const slicedData = showPendentes
    ? listTableTarefasPendentes.slice(startIndex, startIndex + Numberpage)
    : listTableTarefasEmitidas.slice(startIndex, startIndex + Numberpage);
  const firstItem = slicedData[0];
  const [isModalEmitirOpen, setIsModalEmitirOpen] = useState(false);
  const [isEmitidasArquivo, setIsEmitidasArquivo] = useState(false);
  const [isEmitidasEditar, setIsEmitidasEditar] = useState(false);
  const isAnyModalOpen = isModalEmitirOpen || isEmitidasArquivo || isEmitidasEditar;

  const [loadingPendentes, setLoadingPendentes] = useState(false);
  const [loadingEmitidas, setLoadingEmitidas] = useState(false);

  const [taskIdToEmit, setTaskIdToEmit] = useState(null);
  const [obrigacaoIdToEmit, setObrigacaoIdToEmit] = useState(null);
  const [taskIdToEdit, setTaskIdToEdit] = useState(null);
  const [obrigacaoIdToEdit, setObrigacaoIdToEdit] = useState(null);
  const [dados, setDados] = useState();
  const situacaoTarefaRef = useRef(null);

  useEffect(() => {
    // Aqui passamos os argumentos, e agora a função os recebe corretamente
    fetchPendentesData(idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe);
    fetchEmitidasData(idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe);

  }, [idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe]);

  useEffect(() => {
    if (showPendentes) {
      setListTableTarefasPendentes(originalListPendentes);
    } else {
      setListTableTarefasEmitidas(originalListEmitidas);
    }
    setSearchTerm("");
    setPage(1);
  }, [showPendentes, originalListPendentes, originalListEmitidas]);


  // CORREÇÃO: Adicionado carteira e equipe nos parâmetros da função
  const fetchPendentesData = async (idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe) => {
    const url = "/portal/rest/contador/obrigacao/tarefa/item/listar";
    
    const data = {
      dataVencimento: dataVencimento,
      cliente: {
        id: clientId,
        carteira: {
          id: carteira ?? "" // Garante que não vá null
        },
        equipe: {
          id: equipe ?? "" // Garante que não vá null
        }
      },
      obrigacao: {
        id: idTarefa,
        recorrencia: {
          id: selectedArea
        }
      }
    };

    setLoadingPendentes(true);
    try {
      const response = await axios.post(url, data, { withCredentials: true });

      if (response.data.erro) {
        toast.error(response.data.erro.mensagem);
        setListTableTarefasPendentes([]);
        setOriginalListPendentes([]);
        return;
      }

      if (Array.isArray(response.data)) {
        if (response.data.length > 0) {
          setListTableTarefasPendentes(response.data);
          setOriginalListPendentes(response.data);
          console.log("Dados de tarefas pendentes encontrados com sucesso.");
        } else {
          setListTableTarefasPendentes([]);
          setOriginalListPendentes([]);
        }
      } else {
        setListTableTarefasPendentes([]);
        setOriginalListPendentes([]);
      }
    } catch (error) {
      toast.error("Erro ao buscar a tarefa.");
    } finally {
      setLoadingPendentes(false);
    }
  };

  // CORREÇÃO: Adicionado clientId, carteira e equipe nos parâmetros da função
  const fetchEmitidasData = async (idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe) => {
    const url = "/portal/rest/contador/obrigacao/tarefa/item/emitida/listar";
    
    const data = {
      dataVencimento: dataVencimento,
      cliente: {
        id: clientId,
        carteira: {
          id: carteira ?? ""
        },
        equipe: {
          id: equipe ?? ""
        }
      },
      obrigacao: { 
        id: idTarefa, 
        recorrencia: { 
          id: selectedArea 
        } 
      }
    };

    setLoadingEmitidas(true);
    try {
      const response = await axios.post(url, data, { withCredentials: true });

      if (response.data.erro) {
        toast.error(response.data.erro.mensagem);
        setListTableTarefasEmitidas([]);
        setOriginalListEmitidas([]);
        return;
      }

      if (Array.isArray(response.data)) {
        if (response.data.length > 0) {
          setDados(response.data);
          setListTableTarefasEmitidas(response.data);
          setOriginalListEmitidas(response.data);
          // Pega o primeiro ID de arquivo, se existir
          const file = response.data[0]?.id;
          if(file) setIsIdFile(file);
          
          console.log("Dados de tarefas emitidas encontrados com sucesso.");
        } else {
          setListTableTarefasEmitidas([]);
          setOriginalListEmitidas([]);
        }
      } else {
        setListTableTarefasEmitidas([]);
        setOriginalListEmitidas([]);
      }
    } catch (error) {
      toast.error("Erro ao buscar a tarefa.", error);
    } finally {
      setLoadingEmitidas(false);
    }
  };

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    if (searchTerm.trim() === "") {
      if (showPendentes) {
        setListTableTarefasPendentes(originalListPendentes);
      } else {
        setListTableTarefasEmitidas(originalListEmitidas);
      }
    } else {
      if (showPendentes) {
        const filteredData = originalListPendentes.filter((data) =>
          data.cliente.id.toString().includes(searchTerm)
        );
        setListTableTarefasPendentes(filteredData);
      } else {
        const filteredData = originalListEmitidas.filter((data) =>
          data.cliente.id.toString().includes(searchTerm)
        );
        setListTableTarefasEmitidas(filteredData);
      }
    }
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleToggleChange = (checked) => {
    setShowPendentes(!checked);
    setSearchTerm("");
  };

  const handleModalEmitirOpen = (taskId, obrigacaoId, contexto) => {
    setIsModalEmitirOpen(prevState => !prevState);
    setTaskIdToEmit(taskId);
    setObrigacaoIdToEmit(obrigacaoId);
    setDadosContexto(contexto);
  }

  const handleEmitidasEditarOpen = (taskId, obrigacaoId) => {
    setIsEmitidasEditar(!isEmitidasEditar);
    setTaskIdToEdit(taskId);
    setObrigacaoIdToEdit(obrigacaoId);
  }

  const handleFileId = (itemSelected) => {
    setIsEmitidasArquivo(true);
    // Correção de lógica de busca
    if(dados && itemSelected) {
        const found = dados.find(item => item.id === itemSelected.id);
        if(found) setIsIdFile(found.id);
    }
  }

  const ExcelTarefaItens = async (value) => {
    const excelUrl = `/portal/rest/contador/obrigacao/tarefa/item/export/excel`;

    // Sugestão: Se precisar filtrar exportação por carteira/equipe também, adicione aqui
    const params = {
      report: value,
      clienteId: clientId === "" ? 0 : clientId,
      obrigacaoId: idTarefa,
      recorrenciaId: selectedArea,
      // Se o backend suportar, descomente abaixo:
      // carteiraId: carteira,
      // equipeId: equipe
    };

    try {
      setExporting(true) 
      const response = await axios.get(excelUrl, { 
          params,
          withCredentials: true ,
          responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fileName = "relatorio.xlsx";

        switch (value) {
          case "0": fileName = 'planilha-controle.xlsx'; break;
          case "1": fileName = 'tarefas-resumido.xlsx'; break;
          case "2": fileName = 'tarefas-detalhado.xlsx'; break;
          case "9": fileName = 'tarefas-inconsistentes.xlsx'; break;
          case "12": fileName = 'dados-tarefas-detalhado.xlsx'; break;
        }

        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
  
        console.log("Arquivo baixado com sucesso!");
    } catch (error) {
        console.error('Erro ao exportar os dados:', error);
        toast.error('Erro ao exportar os dados, tente novamente em poucos minutos.');
    } finally {
      setExporting(false);
    }
  }

  const handleChange = (value) => {
    setReportType(value);
    ExcelTarefaItens(value);
  };

  return (
    <>
      {!isAnyModalOpen && (
        <>
          <div className="modal-situacao">
            <>
              <div className="header-situacao">
                {firstItem && (
                  <div className="header-description">
                    <div>Dia: {firstItem.obrigacao.dia}</div>
                    <div>Obrigação: {firstItem.obrigacao.nome}</div>
                  </div>
                )}
                <div style={{ width: "50%", position: "relative", right: "10px" }}>
                  <FieldContainer>
                    <div style={{marginRight: 10}}>
                      <Input 
                        value={searchTerm}
                        onChange={handleSearch} 
                        placeholder="Buscar por ID"
                      />
                    </div>

                    {exporting ? (
                    <Box sx={{ width: "100%" }}>
                      <CircularProgress />
                    </Box>
                    ):(
                    <div>
                        <Select
                          defaultValue="Exportar Excel"
                          style={{ width: 200}}
                          onChange={handleChange}
                          options={[
                            {
                              label: <span>Planilha controle</span>,
                              title: "planilha-controle",
                              options: [
                                {
                                  label: <span>Excel - Tarefa Itens</span>,
                                  value: "1",
                                },
                              ],
                            },
                          ]}
                        />
                    </div>
                    )}
                  </FieldContainer>
                </div>
                {loadingPendentes || loadingEmitidas ? (
                  <Box sx={{ width: "100%" }}>
                    <LinearProgress />
                  </Box>
                ) : null}
                <div className="checkbox-wrapper-34">
                  <Switch
                    checkedChildren="Emitidas"
                    unCheckedChildren="Pendentes"
                    defaultChecked
                    checked={!showPendentes}
                    onChange={handleToggleChange}
                  />
                </div>
              </div>
              {loadingPendentes || loadingEmitidas ? (
                <>
                  {[...Array(2)].map((_, index) => (
                    <Skeleton
                      active
                      key={index}
                      variant="rectangular"
                      width="100%"
                      height={10}
                      style={{ padding: "30px" }}
                    />
                  ))}
                </>
              ) : (
                <>
                <TabelasEmitidasPendentes 
                  showPendentes={showPendentes}
                  slicedData={slicedData}
                  handleModalEmitirOpen={handleModalEmitirOpen}
                  handleFileId={handleFileId}
                  handleEmitidasEditarOpen={handleEmitidasEditarOpen}
                  listTableTarefasPendentes={listTableTarefasPendentes}
                  listTableTarefasEmitidas={listTableTarefasEmitidas}
                />

                   <PaginationBtn>
                    <Stack spacing={1}>
                      <Pagination
                        count={Math.ceil(
                          showPendentes
                            ? listTableTarefasPendentes.length / Numberpage
                            : listTableTarefasEmitidas.length / Numberpage
                        )}
                        page={page}
                        onChange={handleChangePage}
                        size="small"
                      />
                    </Stack>
                  </PaginationBtn>
                
                </>
              )}
            </>
          </div >
        </>
      )}

      {isModalEmitirOpen && (
        <div className={`Emitir ${isModalEmitirOpen ? "active" : "inactive"}`} ref={situacaoTarefaRef}>
          <PendentesEmitir
            isOpen={isModalEmitirOpen}
            taskId={taskIdToEmit}
            obrigacaoId={obrigacaoIdToEmit}
            id={idTarefa}
            recorrencia={selectedArea}
            data={dataVencimento}
            clienteId={clientId}
            onClose={() => setIsModalEmitirOpen(false)}
            // Passamos as funções como callbacks, mas observe que elas precisam dos argumentos originais
            // Se o PendentesEmitir chamar sem argumentos, vai falhar.
            // O ideal aqui seria passar uma arrow function que já contem os argumentos ou tratar lá dentro.
            emitidas={() => fetchEmitidasData(idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe)}
            pendentes={() => fetchPendentesData(idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe)}
            Dadoscontexto={Dadoscontexto}
            style={{ height: '100px', backgroundColor: 'lightblue' }}
          />
        </div>
      )}
      {isEmitidasArquivo && (
        <div className="Arquivo">
          <ModalEmitidasArquivo
            isOpen={isEmitidasArquivo}
            idFile={idFile}
            obrigacaoId={obrigacaoIdToEdit}
            taskId={taskIdToEdit}

            onClose={() => setIsEmitidasArquivo(false)}
          />
        </div>
      )}
      {isEmitidasEditar && (
        <div
          className={`Editar ${isEmitidasEditar ? "active" : "inactive"}`}
        >
          <EmitidasEditar
            isOpen={isEmitidasEditar}
            onClose={() => setIsEmitidasEditar(false)}
            obrigacaoId={obrigacaoIdToEdit}
            taskId={taskIdToEdit}
            id={idTarefa}
            recorrencia={selectedArea}
            data={dataVencimento}
            clienteId={clientId}
            emitidas={() => fetchEmitidasData(idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe)}
            pendentes={() => fetchPendentesData(idTarefa, selectedArea, dataVencimento, clientId, carteira, equipe)}
          />
        </div>
      )}
    </>
  );
};

export default SituacaoTarefa;